import { GridReorderBehavior } from "Agile/Scripts/Backlog/GridReorderBehavior";
import TFS_Agile_ProductBacklog_DM = require("Agile/Scripts/Backlog/ProductBacklogDataManager");
import TFS_Agile_ProductBacklog_Grid = require("Agile/Scripts/Backlog/ProductBacklogGrid");
import TFS_Agile_WorkItemChanges = require("Agile/Scripts/Common/WorkItemChanges");
import { BacklogConfigurationService } from "Presentation/Scripts/TFS/FeatureRef/BacklogConfiguration/Service";
import Utils_Array = require("VSS/Utils/Array");
import Utils_String = require("VSS/Utils/String");


export class IterationBacklogGridReorderBehavior extends GridReorderBehavior {
    public isReorderRequirementDisabled: boolean = false;
    public workItemsBlockingReorder: number[] = [];
    public missingWorkItems: number[] = [];

    constructor(
        _grid: TFS_Agile_ProductBacklog_Grid.ProductBacklogGrid,
        _filter: TFS_Agile_WorkItemChanges.ISelectionFilter,
        _enumerator: TFS_Agile_WorkItemChanges.ILocationEnumerator,
        _validator: TFS_Agile_WorkItemChanges.ILocationValidator,
        _selector: TFS_Agile_WorkItemChanges.ILocationSelector,
        _backlogLevelHelper: TFS_Agile_WorkItemChanges.BacklogLevelHelper,
        protected _itemHierarchy: TFS_Agile_WorkItemChanges.IWorkItemDataHierarchy) {
        super(_grid, _filter, _enumerator, _validator, _selector, _backlogLevelHelper);
    }

    public calculateMoveWorkItemsEffect(
        sourceWorkItemIds: number[], targetWorkItemId: number, isReparentingGesture: boolean, isAboveFirstOrBelowLast?: boolean)
        : TFS_Agile_ProductBacklog_DM.IWorkItemMoveEffect {
        if (!sourceWorkItemIds || !sourceWorkItemIds.length ||
            (this.isReorderRequirementDisabled && sourceWorkItemIds.some(id => this._isWorkItemOfRequirementType(id)))) {
            // If reordering is disabled, there is no valid drop location
            return null;
        }

        return super.calculateMoveWorkItemsEffect(sourceWorkItemIds, targetWorkItemId, isReparentingGesture, isAboveFirstOrBelowLast);
    }

    /** Determines whether there is a requirement/requirement hierarchy in this view and enables/disabled ordering accordingly */
    public updateReorderRequirementStatus() {
        var dataManager = this._grid.getDataManager();
        var workItemIds = dataManager.getWorkItemIds();

        this.isReorderRequirementDisabled = false;

        $.each(workItemIds, (index, workItemId) => {
            if (workItemId > 0) {
                // Work items with no parent or parent item on a different backlog level has real parent id of 0
                const parentId = dataManager.getRealParentId(index);
                const hasParent = parentId !== 0;

                // Only task and requirement level items are included in work item ids. If a work item has a high level item parent (e.g. feature) it will return parentId = 0
                // Only items with parents can have same type hierarchy 
                if (hasParent) {
                    const isRequirement = this._isWorkItemOfRequirementType(workItemId);

                    // Because only tasks and requirements are included, if it's not a requirement it is a task.
                    // This is a nested item if... 
                    // 1) It is a requirement and has a parent
                    // 2) It is a task (not requirement) and its parent is a task (not requirement)
                    const isNestedItem = isRequirement || (!isRequirement && !this._isWorkItemOfRequirementType(parentId));

                    if (isNestedItem) {
                        this.isReorderRequirementDisabled = true;
                        this.workItemsBlockingReorder.push(workItemId);

                        // Requirement parents might not be filtered out of the list if they have task children. 
                        // Don't list them missing if they're shown                        
                        const isParentShown = workItemIds.indexOf(parentId) !== -1;
                        const isParentAlreadyIncluded = this.missingWorkItems.indexOf(parentId) !== -1;

                        // Add parent to the missing work items list, if it isn't already included and it isn't shown on the page
                        if (!isParentAlreadyIncluded && !isParentShown) {
                            this.missingWorkItems.push(parentId);
                        }
                    }
                }
            }
        });
    }

    /**
     * Best effort determines if work item is of type requirement based off its id. 
     */
    private _isWorkItemOfRequirementType(workItemId: number): boolean {
        // If the work item is an unmaterialized parent (i.e. same-type hierarchy parent) work item data may be null. We will return requirement type as false.         
        let workItemData = this._itemHierarchy.getData(workItemId);
        return workItemData && Utils_Array.contains(BacklogConfigurationService.getBacklogConfiguration().requirementBacklog.workItemTypes, workItemData.type, Utils_String.ignoreCaseComparer);
    }
}
